export const MODAL_PAUSE = 'pause';
export const MODAL_SHARE = 'share';
export const MODAL_DELETE_DRAFT = 'deleteDraft';

export const REASON_TO_PAUSE_STATUS_NO_ASSETS = 'no-assets';
